import { render, staticRenderFns } from "./tableHistory.vue?vue&type=template&id=607ffab2&scoped=true"
import script from "./tableHistory.vue?vue&type=script&lang=js"
export * from "./tableHistory.vue?vue&type=script&lang=js"
import style0 from "./tableHistory.vue?vue&type=style&index=0&id=607ffab2&prod&scoped=true&lang=css"
import style1 from "./tableHistory.vue?vue&type=style&index=1&id=607ffab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ffab2",
  null
  
)

export default component.exports